module.exports = __webpack_public_path__ + "img/v_capital.3193515c.jpeg";